import React from "react";
import { i18n, getBrandLogo, useGetFileById } from "src/common";
import { colors } from "src/theme";
import { Flex } from "../grid";
import { DownloadFileIcon } from "../icons";
import { Card } from "./card";
import { Text } from "../typography";
import styled from "@emotion/styled";
import { GetTermsAndConditionsQuery } from "src/common/apiGraphql/types/types";

const FlexStyle = styled(Flex)<{ isModal?: boolean }>(({ isModal }) => ({
  marginTop: 32,
  ...(isModal && {
    marginTop: 0
  })
}))

const LinkStyle = styled.a({
  color: colors.text7,
  cursor: 'pointer',
  textDecoration: 'none',

  '&:hover': {
    color: colors.text5
  },
})

const LogoContainerStyle = styled(Flex)({
  width: 64,
  height: 24,
})

const LogoStyle = styled.img({
  maxWidth: '100%',
  height: 37,
  objectFit: 'contain',
  objectPosition: 'left',
})
const TermsCard = ({ termsAndConditions, isModal }: { termsAndConditions: GetTermsAndConditionsQuery['getTermsAndConditions'], isModal?: boolean }) => {
  const { downloadFile } = useGetFileById();

  const download = (e: React.MouseEvent<HTMLAnchorElement>, fileId: string) => {
    e.preventDefault();
    downloadFile(fileId, true)
  }
  if (!termsAndConditions) return null;
  return (
    <Card>
    <Flex vertical gap={32}>
     {!isModal && <Flex vertical gap={8}>
        <Text type="xLarge" bold>{i18n.t('pages.termsAndConditionsPage.title')}</Text>
      </Flex>
      }
      <Flex vertical gap={8}>
        <React.Fragment key={termsAndConditions.brandName}>
          {!isModal && (
          <Flex align="center" gap={12}>
            <LogoContainerStyle justify="start">
              <LogoStyle src={getBrandLogo(termsAndConditions.brandCode)} alt={termsAndConditions.brandName} />
            </LogoContainerStyle>
            <Text type="base">{termsAndConditions.brandName}</Text>
          </Flex>
          )}
          <FlexStyle vertical gap={24} isModal={isModal}>
            {termsAndConditions.documents.map((doc) => (
              <Flex key={doc.fileId} justify="space-between" align="center" gap={12}>
                <Text color={colors.text2} type="base">{doc.fileName}</Text>
                <LinkStyle href="#" onClick={(e) => { download(e, doc.fileId) }} ><DownloadFileIcon width={20} height={20} /></LinkStyle>
              </Flex>
            ))}
          </FlexStyle>
        </React.Fragment>
      </Flex>
    </Flex>
  </Card>
  );
};

export default TermsCard;